import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as SessionActions from '../../stores/actions/session';
import * as ModalActions from '../../stores/actions/modal';
import { GreenroomState } from '../../stores/types/types';
import { MODAL_AVATAR_ACTIONS, MODAL_TEMPLATES } from '../../stores/reducers/modal';
import TextInput from '../general-components/text-input';
import Avatar from '../general-components/avatar';
import Icon, { ICONS, COLORS } from '../general-components/icon';

export default function ConfirmInfo() {
	const user = useSelector((state: GreenroomState) => state.SessionReducer.user);
	const token = useSelector((state: GreenroomState) => state.SessionReducer.token);
	const appSignedInWith = useSelector(
		(state: GreenroomState) => state.SessionReducer.appSignedInWith,
	);
	const showroomsTokens = useSelector(
		(state: GreenroomState) => state.SessionReducer.showroomsTokens,
	);
	const loadingProfile = useSelector(
		(state: GreenroomState) => state.SessionReducer.loadingProfile,
	);
	const dispatch = useDispatch();
	const [firstName, setFirstName] = useState(user?.first_name);
	const [lastName, setLastName] = useState(user?.last_name);
	const [location, setLocation] = useState(user?.location);
	const [title, setTitle] = useState(user?.title);

	useEffect(() => {
		setFirstName(user?.first_name);
		setLastName(user?.last_name);
		setLocation(user?.location);
		setTitle(user?.title);
	}, [loadingProfile, user]);

	function blur() {
		if (token) {
			const columns = {
				first_name: firstName,
				last_name: lastName,
				title,
				location,
			};
			// Update profile locally and on whatever app the user used to sign in with
			if (user) {
				dispatch(SessionActions.updateProfile(
					user.gr_user,
					appSignedInWith,
					columns,
					token,
					showroomsTokens?.accessToken,
				));
			}
		}
	}

	function fullySetUp() {
		if (user) {
			return user.first_name
				&& user.last_name
				&& user.location
				&& user.title
				&& user.avatar;
		}
		return false;
	}

	function openAvatarPhotoModal() {
		dispatch(ModalActions.setModalState({
			modalOpen: true,
			modalTemplate: MODAL_TEMPLATES.AVATAR_PHOTO,
			modalData: {
				isOnboarding: true,
				modalAvatarAction: MODAL_AVATAR_ACTIONS.AVATAR,
			},
		}));
	}

	useEffect(() => {
		// need to update user and save what we have upon first load
		blur();
	}, []);

	return (
		<div className="panel teal-green confirm-info">
			<p className="header">{fullySetUp() ? 'Confirm your info since it may show on the screen' : 'Please check that your info is correct before joining'}</p>
			<section className="avatar-container">
				{user && <Avatar user={user} />}
				<button
					onClick={openAvatarPhotoModal}>
					<Icon
						name={ICONS.PHOTO}
						color={COLORS.WHITE}
						size={15}
					/>
					</button>
			</section>
			<section>
				<TextInput
					placeholder={'First Name'}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
					onBlur={blur}
					value={firstName ?? ''}
				/>
				<TextInput
					placeholder={'Last Name'}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
					value={lastName ?? ''}
					onBlur={blur}
				/>
				<TextInput
					placeholder={'Title'}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTitle(e.target.value)}
					value={title ?? ''}
					onBlur={blur}
				/>
				<TextInput
					placeholder={'Location'}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLocation(e.target.value)}
					value={location ?? ''}
					onBlur={blur}
				/>
			</section>
		</div>
	);
}
